/**
 * @typedef {object} AlertAction
 *
 * Something the user can do on an alert.
 * @property {Renderable} label - What to show as text for the action
 * @property {string} href - URL where the user should be redirected
 * @property {string} [dataTest] - Identifier to find the action for the testing tool
 */

/**
 * Superclass of all alerts.
 *
 * @abstract
 * @param {polyglotObject} description - User-visible text describing the validation problem
   @param {AlertAction[]} actions - Things the user can do with this alert
 */
export default class AbstractAlert {
	constructor({ description, actions = [] }) {
		this._description = description;
		this._actions = actions;
	}

	getDescription() {
		return this._description;
	}

	getActions() {
		return this._actions;
	}

	isError() {
		return false;
	}

	isWarning() {
		return false;
	}

	asException() {
		return new Error(this._description);
	}
}
